import * as types from "@/vuex/types"

//API
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { paginationParams, deviceParams } from '@/api/params'

const state = {
  all: {
    results: []
  },
}

const getters = {
  allDevices: state => state.all,
}

const actions = {
  async getAllDevices ({ commit }, payload ) {
    const { categoryName, newNext } = payload
    newNext ? paginationParams.page += newNext : paginationParams
    const params = {
      ...paginationParams,
      ...deviceParams[categoryName]
    }

    commit(types.ALL_DEVICES, await api.get(apiV2.devices, { ...params }))
  }
}

const mutations = {
  [types.ALL_DEVICES] (state, response) {
    const { data } = response
    if(state.all.results.length){
      state.all = {
        count: data.count,
        next: data.next,
        previous: data.previous,
        results: state.all.results.concat(data.results)
      }
    }else {
      state.all = data
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}